import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy, Star, Gift } from 'lucide-react';
import { Button } from './ui/button';

export const LoyaltyWidget = () => {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #d4af37 0%, #b8941f 100%)',
      borderRadius: '12px',
      padding: '32px',
      textAlign: 'center',
      color: '#000000',
      margin: '40px 0',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.1,
        backgroundImage: `
          radial-gradient(circle at 25% 25%, rgba(0,0,0,0.2) 2px, transparent 2px),
          radial-gradient(circle at 75% 75%, rgba(0,0,0,0.2) 2px, transparent 2px)
        `,
        backgroundSize: '40px 40px'
      }} />
      
      <div style={{ position: 'relative', zIndex: 2 }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          marginBottom: '20px'
        }}>
          <Trophy size={32} style={{ marginRight: '12px' }} />
          <h3 style={{ 
            fontSize: '1.8rem', 
            fontWeight: '600',
            margin: 0,
            fontFamily: "'Playfair Display', serif"
          }}>
            Earn Loyalty Rewards
          </h3>
        </div>
        
        <p style={{ 
          fontSize: '1.1rem', 
          marginBottom: '24px',
          opacity: 0.9,
          maxWidth: '500px',
          margin: '0 auto 24px auto'
        }}>
          Every booking earns points! Unlock exclusive discounts, free appetizers, 
          and VIP experiences with our luxury rewards program.
        </p>
        
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '32px',
          marginBottom: '28px',
          flexWrap: 'wrap'
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Star size={20} style={{ marginRight: '8px' }} />
            <span style={{ fontSize: '0.95rem', fontWeight: '500' }}>500pts per Event</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Gift size={20} style={{ marginRight: '8px' }} />
            <span style={{ fontSize: '0.95rem', fontWeight: '500' }}>Exclusive Rewards</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Trophy size={20} style={{ marginRight: '8px' }} />
            <span style={{ fontSize: '0.95rem', fontWeight: '500' }}>3 Tier System</span>
          </div>
        </div>
        
        <Link to="/loyalty">
          <Button style={{
            background: '#000000',
            color: '#ffffff',
            border: 'none',
            padding: '14px 28px',
            fontSize: '16px',
            fontWeight: '600',
            borderRadius: '6px',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#333333';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = '#000000';
            e.target.style.transform = 'translateY(0)';
          }}>
            View My Rewards
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default LoyaltyWidget;